export default "__VITE_ASSET__DmqVdTAK__"